import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';
import { InvoiceService } from './invoice.service';
import { Utils } from '../../../shared/utils';
import { FacturaEResponseModel } from './invoice-dialog-facturae-response.model';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';

@Component({
  selector: 'convfact-invoicefacturae',
  templateUrl: './invoice-dialog-facturae.component.html',
  styleUrls: ['./invoice-dialog-facturae.component.css'],
  standalone: false
})
export class InvoiceDialogFacturaEComponent implements OnInit {

  uid: string;
  invoiceNumber = 'Facturae';

  file: File;
  hasCertificate = true;
  certPassword: string;
  showPassword = false;
  hasDIR3 = false;

  submitted = false;
  generating = false;
  responseModel: FacturaEResponseModel;

  constructor(
    public dialogRef: MatDialogRef<InvoiceDialogFacturaEComponent>,
    public invoiceService: InvoiceService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notify: NotificationService,
  ) { }

  ngOnInit(): void {
    this.uid = this.data.uid;
    if (!Utils.IsNullOrEmpty(this.data.invoiceNumber)) {
      this.invoiceNumber = this.data.invoiceNumber;
    }
  }

  fileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.file = input.files[0];
    }
  }

  save(): void {
    this.submitted = true;
    if (this.hasCertificate && !this.file) {
      this.notify.warning('Selecciona tu certificado electrónico');
      return;
    }

    const formData = new FormData();
    formData.append('uid', this.uid);
    formData.append('hasDIR3', this.hasDIR3 ? 'true' : 'false');
    formData.append('hasCertificate', this.hasCertificate ? 'true' : 'false');
    if (this.hasCertificate) {
      formData.append('password', this.certPassword || '');
      formData.append('file', this.file);
    }

    this.generating = true;
    this.dialogRef.disableClose = true;

    this.invoiceService.generateFacturae(formData)
      .then(response => {
        FileSaver.saveAs(new Blob([response]), this.invoiceNumber + (this.hasCertificate ? '.xsig' : '.xml'));
        this.notify.ok('Factura electrónica generada correctamente');
        this.dialogRef.close(true);
      })
      .catch(async error => {
        this.generating = false;
        this.dialogRef.disableClose = false;

        let responseError: any = null;
        try {
          responseError = JSON.parse(await error.error.text());
        } catch {
          responseError = null;
        }

        if (responseError && responseError.data) {
          this.responseModel = responseError.data;
        }
        this.notify.error((responseError && responseError.message) || 'No se pudo generar la factura electrónica');
      });
  }

  closeDialog(): void {
    if (this.generating) return;
    this.dialogRef.close();
  }
}
